import { Injectable } from '@angular/core';
import { BehaviorSubject,  Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  Notifications: BehaviorSubject<any> = new BehaviorSubject(null);
  Loading = new Subject<boolean>();
    Messages: any = {
    Update: {
      Type: "success",
      Message: "Updated!",
      Body: `Item was updated successfully`
    },
    Created: {
      Type: "success",
      Message: "Created!",
      Body: `Item created succcessfully.`
    },
    Deactivated: {
      Type: "warning",
      Message: "Deactivated!",
      Body: `Item deactived succcessfully.`
    },
    Deleted: {
      Type: "danger",
      Message: "Deleted!",
      Body: `Item deleted succcessfully.`
    },
    Collected: {
      Type: "success",
      Message: "Collected!",
      Body: `Pool data collected successfully.`
    },
    Exported: {
      Type: "success",
      Message: "Exported!",
      Body: `Data exported successfully.`
    }
  }

  constructor() { }
}
